<div class="wrapper shadowed">
    <h4>Gestion des utilisateurs</h4>


<app-gmao-spinner *ngIf="!usersList"></app-gmao-spinner>

<mat-table [dataSource]="usersList">
    <ng-container matColumnDef="login">
        <mat-header-cell *matHeaderCellDef> Login </mat-header-cell>
        <mat-cell *matCellDef="let user"> {{user.login}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="nom">
        <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
        <mat-cell *matCellDef="let user"> {{user.nom}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="prenom">
        <mat-header-cell *matHeaderCellDef> Prénom </mat-header-cell>
        <mat-cell *matCellDef="let user"> {{user.prenom}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> Editer </mat-header-cell>
        <mat-cell  *matCellDef="let user"> <mat-icon (click)="editUser(user)">edit</mat-icon> </mat-cell>
    </ng-container>
    <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> Supprimer </mat-header-cell>
        <mat-cell  *matCellDef="let user"> <mat-icon (click)="deleteUser(user.login)">delete</mat-icon> </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumn"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['login', 'nom', 'prenom', 'edit', 'delete'] ;"></mat-row>
</mat-table>



</div>


